<ng-template #statWidgets>
  <div class="row g-3">
    @for (stat of statData; track $index) {
      <div class="col-xl-3 col-md-6 stat-box d-flex">
        <app-stat-tile
          [accentColour]="stat.iconColour ?? 'primary'"
          [caption]="stat.subTitle"
          class="flex-grow-1 h-100"
          [decimalPlaces]="stat.decimalPlaces ?? 0"
          [icon]="stat.icon"
          [label]="stat.title ?? ''"
          [loading]="stat.loading"
          [prefix]="stat.prefix"
          [suffix]="usageSuffix(stat)"
          [trendPercent]="trendPercent(stat.showProfit, stat.percentage)"
          [trendUpIsGood]="stat.profitUpIsGood ?? true"
          [useCountUp]="useCountUp"
          [value]="usageValue(stat)"
        >
          @if (!stat.loading && (stat.secondaries?.length ?? 0)>0) {
            <div class="usage-stat-secondaries d-flex flex-wrap mt-1">
              @for (sec of stat.secondaries; track $index) {
                <span class="me-3 text-nowrap">
                  <span class="fw-semibold">+ {{ sec.prefix }}{{ sec.value | number:'1.2-2' }}</span>
                  @if (trendPercent(true, sec.percentage)!==null) {
                    <span class="fw-semibold ms-1" [ngClass]="secondaryTrendClass(sec)"><i class="align-middle" [ngClass]="secondaryTrendIcon(sec)"></i>{{ secondaryTrendSize(sec) | number:'1.1-1' }}%</span>
                  }
                </span>
              }
            </div>
          }
        </app-stat-tile>
      </div>
    }
  </div>
</ng-template>

@if (useContainer) {
  @if (visibleContainer) {
    <div class="row" [ngClass]="marginBottom">
      <div class="col-12">
        <div class="border border-success rounded ss-grey-panel">
          <div class="row">
            <div class="col-12">
              <div class="alert border-0 alert-primary d-flex justify-content-between align-items-center mb-0"
                   role="alert">
                <strong>{{containerTitle}}</strong>
                <div class="d-flex align-items-center" style="gap: 6px;">
                  <i class="fs-5"
                     [ngClass]="expandContainer ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
                     style="cursor: pointer; color: #198754;"
                     (click)="toggleContainerExpansion()">
                  </i>
                  <i *ngIf="allowContainerClose"
                     class="fs-3 bx bx-x"
                     style="cursor: pointer; color: #dc3545;"
                     (click)="closeContainer()">
                  </i>
                </div>
              </div>
            </div>
          </div>

          @if (expandContainer) {
            <div class="row">
              <div class="col-12">
                <div class="mb-2 w-100">
                  <ng-container *ngTemplateOutlet="statWidgets"></ng-container>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
} @else {
  <ng-container *ngTemplateOutlet="statWidgets"></ng-container>
}
